import { render, staticRenderFns } from "@/style-guide/partials/btn/btn.pug?vue&type=template&id=e8b3ee1e&scoped=true&lang=pug&external"
import script from "./btn.vue?vue&type=script&lang=ts"
export * from "./btn.vue?vue&type=script&lang=ts"
import style0 from "./btn.vue?vue&type=style&index=0&id=e8b3ee1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3ee1e",
  null
  
)

export default component.exports